import React from 'react';
import dayjs from 'dayjs';

import {
  SitrepCardSurface,
  type GetSitrepsResponse,
} from 'components/Reports/reports.types';

type SitrepCardHeaderProps = {
  sitrep: GetSitrepsResponse;
  incidentName: string | null;
  aorName: string | null;
  surface?: SitrepCardSurface;
};

/** Shared header chrome for all SITREP card surfaces. */
const SitrepCardHeader: React.FC<SitrepCardHeaderProps> = ({
  sitrep,
  incidentName,
  aorName,
  surface,
}) => {
  const isPendingReviewDraft =
    surface === SitrepCardSurface.Draft && sitrep.approval_status === 'PENDING';

  const statusConfig =
    surface === SitrepCardSurface.Review
      ? {
          key: 'pending-approval',
          label: 'Pending Approval',
        }
      : isPendingReviewDraft
        ? {
            key: 'pending-review',
            label: sitrep.pending_reviewer_names
              ? `Pending review by ${sitrep.pending_reviewer_names}`
              : 'Pending review',
          }
        : surface === SitrepCardSurface.Draft
          ? {
              key: 'draft',
              label: 'Draft',
            }
          : null;

  return (
    <div className="d-flex flex-column">
      <div className="txt--semibold txt--lg">
        SITREP{incidentName ? `: ${incidentName}` : aorName || ''}
      </div>
      <div className="txt--sml">
        {sitrep.approvals?.[0] && (
          <>
            Approved by: {sitrep.approvals[0].approved_by_user_name} at{' '}
            {dayjs(sitrep.approvals[0].approved_at).format('MMM DD, HH:mm')}
          </>
        )}
        {statusConfig && (
          <div className="d-flex align-items-center mt-1 gap-2">
            <small
              className={`reports-card__status reports-card__status--${statusConfig.key}`}
            >
              <span
                className={`reports-card__status-dot reports-card__status-dot--${statusConfig.key}`}
              />
              {statusConfig.label}
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default SitrepCardHeader;
